import PropTypes from 'prop-types';
import SellerInfo from '../../../../../components/SellerInfo/Desktop/v2';
import { RatingAndReviews } from '../../../../../external_dependencies/ratingAndReviews/RatingAndReviews';
import { PDPBasicInfoDesktopStyle } from './style';

const PDPBasicInfoDesktop = ({ product, appCtx }) => {
  const store = appCtx?.store;
  const hideBrandStores = ['fa_america', 'fa_carters', 'fa_aldo', 'fa_crabarr'];
  const shouldHideBrand = hideBrandStores.includes(store);

  return (
    <div className="pdp-basic-info">
      <div className="pdp-basic-info__header">
        <div className="pdp-basic-info__title-container">
          {!shouldHideBrand && (
            <span className="pdp-basic-info__brand-and-separator">
              <a
                href={`https://www.falabella.com/falabella-cl/brand/${encodeURIComponent(product.brandName)}`}
                className="pdp-basic-info__brand-link"
              >
                {product.brandName}
              </a>
              <span className="pdp-basic-info__separator">|</span>
            </span>
          )}
          <h1 className="pdp-basic-info__product-name">{product.name}</h1>
        </div>
      </div>

      <div className="pdp-basic-info__seller">
        <SellerInfo product={product} />
        <RatingAndReviews />
      </div>

      <style jsx>{PDPBasicInfoDesktopStyle}</style>
    </div>
  );
};

PDPBasicInfoDesktop.propTypes = {
  product: PropTypes.object.isRequired,
  appCtx: PropTypes.object,
};

PDPBasicInfoDesktop.defaultProps = {
  appCtx: {},
};

export default PDPBasicInfoDesktop;
